import { BaseService } from "./../../base";
export class DaySelectedService extends BaseService {
  static get entity() {
    return "day_selected";
  }
  static get name() {
    return "day_selected";
  }
  static async PostItems(array) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/post_items`, this.name, array);
  }
  static async findByDateAndScheduleId(id, date) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_schedule_id_and_date/${id}/${date}`, this.name);
  }
  static async findByDate(date) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_date/${date}`, this.name);
  }

  /**
   * Bloquea el DaySelected, se crea registro en DaySelectedHistory, se bloquean todos los ScheduleDetail que tenga,
   * ingresando su respectivo ScheduleDetailHistory
   * (Toda esta acción asume que en el front se hizo un validación que no hayan citas en el día y se encuentre disponible para bloquear)
   *
   * El data debe ser un objeto con los siguientes valores
   *  -motive_locked_id -> el motivo por el que se bloquea
   *  -day_selected_id -> el día que se quiere bloquear
   *  -user_id -> el usuario que realiza la acción
   */
  static async blockDaySelected(data) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/block_day_selected`, this.name, data);
  }
  static async getByScheduleId(id) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_schedule_id/${id}`, this.name);
  }
  static async removeDaysSelecteds(array) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/remove_days_selecteds`, this.name, array);
  }
  static async findDayScheduleByDayScheduleId(id) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_schedule_id_distinct/${id}`, this.name);
  }
}
